import { ActionTree } from 'vuex';

// import { ILoginStore } from '../../../shared/store/shared.types';
import { IAuthenticationState } from './authentication.types';

import { ILoginParams } from '../../../services/auth-service/auth-service.types';
import { login } from '@/modules/login/services/auth-service';

const actions: ActionTree<IAuthenticationState, any> = {
  login({ rootState, state }): any {
    const params: ILoginParams = {
      userId: rootState.loginModule.metaInfo.userId,
      sykValue: rootState.loginModule.verificationModule.sykValue,
      pinCode: state.pinCode,
    };

    return login(params);
  },

  setPinCode({ commit }, code: string): void {
    commit('setPinCode', code);
  },

  unsetPinCode({ commit }): void {
    commit('setPinCode', '');
  },

  setNetworkError({ commit }, error: string): void {
    commit('setNetworkError', error);
  },

  setAuthError({ commit }, error: string): void {
    commit('setAuthError', error);
  },
};

export default actions;
